var _defs, _g, _ellipse, _ellipse2, _ellipse3, _ellipse4, _circle, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _circle2, _text, _ellipse9, _circle3, _circle4, _circle5, _circle6, _ellipse10, _ellipse11, _circle7, _ellipse12, _ellipse13, _g2, _g3, _g4, _g5, _g6, _text2, _text3, _g7, _path, _g8, _text4, _text5, _text6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHotspotsLettersAnalyzer = function SvgHotspotsLettersAnalyzer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 152.282 148.223"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotspots_letters_analyzer_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hotspots_letters_analyzer_svg__b",
    width: 128.463,
    height: 124.9,
    x: 0,
    y: 23.323,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.231
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity",
      isolation: "isolate"
    },
    transform: "translate(-5.868 -37)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#cfcfce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m79.63 141.597-13.436-11.692-44.146 40.132H157.8l-51.125-57.232Z",
    "data-name": "Path 9097"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.128 101.987a8.724 8.724 0 1 1-8.724-8.724 8.724 8.724 0 0 1 8.724 8.724",
    "data-name": "Path 9098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.022 170.038h5.409l46.763-42.4 13.261 11.517 27.22-28.965 51.474 57.581V77.559H14.022Zm23.38-78.694a10.47 10.47 0 1 1-10.47 10.47 10.5 10.5 0 0 1 10.47-10.47",
    "data-name": "Path 9099"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6,
    cy: 6.5,
    fill: "#f54f4f",
    "data-name": "Ellipse 119",
    opacity: 0.79,
    rx: 6,
    ry: 6.5,
    transform: "translate(45 104.65)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6,
    cy: 6.5,
    fill: "#f54f4f",
    "data-name": "Ellipse 139",
    opacity: 0.79,
    rx: 6,
    ry: 6.5,
    transform: "translate(58 141.65)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.5,
    cy: 6,
    fill: "#6cc959",
    "data-name": "Ellipse 120",
    opacity: 0.79,
    rx: 6.5,
    ry: 6,
    transform: "translate(51 111.65)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.5,
    cy: 6,
    fill: "#6cc959",
    "data-name": "Ellipse 140",
    opacity: 0.79,
    rx: 6.5,
    ry: 6,
    transform: "translate(66 145.65)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#6cc959",
    "data-name": "Ellipse 123",
    opacity: 0.79,
    transform: "translate(110 132.65)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.5,
    cy: 6,
    fill: "#f89c3f",
    "data-name": "Ellipse 124",
    opacity: 0.79,
    rx: 6.5,
    ry: 6,
    transform: "translate(119 129.65)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6,
    cy: 6.5,
    fill: "#f89c3f",
    "data-name": "Ellipse 130",
    opacity: 0.79,
    rx: 6,
    ry: 6.5,
    transform: "translate(110 123.65)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.5,
    cy: 6,
    fill: "#f54f4f",
    "data-name": "Ellipse 126",
    opacity: 0.79,
    rx: 6.5,
    ry: 6,
    transform: "translate(113 140.65)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6,
    cy: 6.5,
    fill: "#6cc959",
    "data-name": "Ellipse 127",
    opacity: 0.79,
    rx: 6,
    ry: 6.5,
    transform: "translate(110 148.65)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#6cc959",
    "data-name": "Ellipse 133",
    opacity: 0.79,
    transform: "translate(132 107.65)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "ArialMT, Arial",
    fontSize: 4,
    transform: "translate(55 118.649)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C"))), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6,
    cy: 6.5,
    fill: "#f89c3f",
    "data-name": "Ellipse 129",
    opacity: 0.79,
    rx: 6,
    ry: 6.5,
    transform: "translate(120 141.65)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    fill: "#f89c3f",
    "data-name": "Ellipse 135",
    opacity: 0.79,
    transform: "translate(51 117.65)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#6cc959",
    "data-name": "Ellipse 136",
    opacity: 0.79,
    transform: "translate(48 126.65)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    fill: "#6cc959",
    "data-name": "Ellipse 138",
    opacity: 0.79,
    transform: "translate(51 138.65)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#f89c3f",
    "data-name": "Ellipse 137",
    opacity: 0.79,
    transform: "translate(45 134.65)"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.5,
    cy: 6,
    fill: "#f89c3f",
    "data-name": "Ellipse 134",
    opacity: 0.79,
    rx: 6.5,
    ry: 6,
    transform: "translate(138 101.65)"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.5,
    cy: 6,
    fill: "#f89c3f",
    "data-name": "Ellipse 132",
    opacity: 0.79,
    rx: 6.5,
    ry: 6,
    transform: "translate(123 111.65)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#f54f4f",
    "data-name": "Ellipse 131",
    opacity: 0.79,
    transform: "translate(117 117.65)"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.5,
    cy: 6,
    fill: "#f54f4f",
    "data-name": "Ellipse 121",
    opacity: 0.79,
    rx: 6.5,
    ry: 6,
    transform: "translate(51 97.65)"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6,
    cy: 6.5,
    fill: "#6cc959",
    "data-name": "Ellipse 141",
    opacity: 0.79,
    rx: 6,
    ry: 6.5,
    transform: "translate(48 88.65)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 478",
    transform: "translate(14 37)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.831,
    height: 19.866,
    fill: "#f54f4f",
    "data-name": "Rectangle 358",
    rx: 6
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Arial-BoldMT, Arial",
    fontSize: 10,
    fontWeight: 700,
    transform: "translate(14 12.65)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A")))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 479",
    transform: "translate(53.731 37)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.831,
    height: 19.866,
    fill: "#f89c3f",
    "data-name": "Rectangle 358",
    rx: 6
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Arial-BoldMT, Arial",
    fontSize: 9,
    fontWeight: 700,
    transform: "translate(15.269 12.65)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "B")))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 480",
    transform: "translate(93.462 37)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.831,
    height: 19.866,
    fill: "#6cc959",
    "data-name": "Rectangle 358",
    rx: 6
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    "data-name": "C",
    fontFamily: "Arial-BoldMT, Arial",
    fontSize: 9,
    fontWeight: 700,
    transform: "translate(14.538 12.65)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C")))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 482",
    transform: "translate(133.194 37)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.956,
    height: 19.866,
    fill: "#42424f",
    "data-name": "Rectangle 358",
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.395 7.056v7.134a1.464 1.464 0 0 1-1.453 1.453h-4.933a1.44 1.44 0 0 1-1.456-1.453V7.056h-.777a.338.338 0 0 1 0-.676h2.365v-.367a1.053 1.053 0 0 1 1.051-1.047h2.568a1.053 1.053 0 0 1 1.047 1.047v.372h2.365a.338.338 0 0 1 0 .676ZM10.82 6.38h3.311v-.367a.375.375 0 0 0-.372-.372h-2.568a.375.375 0 0 0-.372.372v.372Zm-1.588.676v7.134a.765.765 0 0 0 .777.777h4.933a.786.786 0 0 0 .777-.777V7.056z",
    "data-name": "Path 9100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.719 8.851a.338.338 0 0 1 .676 0v4.291a.338.338 0 0 1-.676 0Z",
    "data-name": "Path 9101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.557 8.851a.338.338 0 0 1 .676 0v4.291a.338.338 0 0 1-.676 0Z",
    "data-name": "Path 9102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.138 8.851a.338.338 0 0 1 .676 0v4.291a.338.338 0 0 1-.676 0Z",
    "data-name": "Path 9103"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2166"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "url(#hotspots_letters_analyzer_svg__a)",
    stroke: "#707070",
    "data-name": "Rectangle 30212",
    opacity: 0.58,
    transform: "rotate(-90 42.325 28.325)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 142,
    stroke: "none",
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 141,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 3
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2147"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2146"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#707070",
    stroke: "#707070",
    "data-name": "Rectangle 30213"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M134 61.65h11v11h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M134.5 62.15h10v10h-10z"
  })))))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    "data-name": "C",
    fontFamily: "ArialMT, Arial",
    fontSize: 4,
    transform: "translate(53 133.649)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    "data-name": "C",
    fontFamily: "ArialMT, Arial",
    fontSize: 4,
    transform: "translate(53 96.649)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    "data-name": "photo"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cfcfce",
    d: "M14.022 170.038H158.15V77.559H14.022Zm39.936-80.7c9.531 0 20.163-6.69 20.163 3.049 0 3.935 12.614 6.516 9.824 13.381-3.887 9.57 5.68 11.01 0 11.01-2.783 0 1 11.048-5.251 11.179-4.322.091-7.659 9.267-13.551 7.621-3.779-1.056-11.552.164-15.581-2.71-3.889-2.772-7.56-5.352-9.824-9.485a32.5 32.5 0 0 1-3.387-13.3c0-9.731 8.076-20.741 17.607-20.741Z",
    "data-name": "Path 9099",
    opacity: 0.79
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#565656",
    d: "M41.217 96.393a25.1 25.1 0 0 0 22.169 40.751c.048.005.087.001.136.005s.094-.03.14-.043a25.056 25.056 0 0 0 21.619-30.123l-.019-.172c-.013-.047-.027-.074-.041-.121a25.093 25.093 0 0 0-44.004-10.297m37.03 29.986c-3.587 4.43 4.193-5.177 0 0m4.188-20.266a23.08 23.08 0 0 1-4.187 20.266c-4.082 5.212-7.285 6.978-16.297 8.312a22.543 22.543 0 1 1 20.487-28.576Z",
    "data-name": "Path 18653"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#hotspots_letters_analyzer_svg__b)",
    transform: "matrix(1 0 0 1 5.862 37.001)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#565656",
    d: "M86.403 66.955a32.607 32.607 0 1 0-29.188 40.752 16 16 0 0 0 2.538-.286 32.6 32.6 0 0 0 11.6-4.084l3.833 2.631a1.277 1.277 0 0 0 1.805-.18l2.832-3.498 11.974 8.315a5.719 5.719 0 1 0 7.198-8.888l-11.974-8.324 2.832-3.497a1.276 1.276 0 0 0-.198-1.803l-3.844-2.64a32.75 32.75 0 0 0 1.145-15.989c.022-.012-.517-2.463-.553-2.51M78.21 94.107a30.046 30.046 0 1 1-4.429-42.263 30.07 30.07 0 0 1 4.43 42.263",
    "data-name": "Path 18654"
  }))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    "data-name": "A",
    fontFamily: "ArialMT, Arial",
    fontSize: 3,
    transform: "translate(56 103.649)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    "data-name": "A",
    fontFamily: "ArialMT, Arial",
    fontSize: 3,
    transform: "translate(50 111.649)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    "data-name": "B",
    fontFamily: "ArialMT, Arial",
    fontSize: 3,
    transform: "translate(56 124.649)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "B")))));
};
export default SvgHotspotsLettersAnalyzer;